import { styled, ToggleButtonGroup } from "@mui/material";

/**
 * Styled ToggleButtonGroup with variant support
 */
export const StyledToggleButtonGroup = styled(ToggleButtonGroup, {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: "default" | "queen" }>(({ theme, variant = "default" }) => ({
  width: "fit-content",
  height: 36,
  border: variant === "queen" ? "none" : "1px solid black",
  borderRadius: "8px",
  padding: variant === "queen" ? 0 : 3,
  gap: 5,
  alignItems: "center",
  "& .MuiToggleButton-root": {
    width: 28,
    height: 28,
    minWidth: 28,
    padding: 0,
    border: "none",
    borderRadius: "6px",
    "& svg": {
      fontSize: "1rem",
    },
    "&.Mui-selected": {
      backgroundColor:
        variant === "queen"
          ? theme.palette.background["paper-elevation-2"]
          : theme.palette.text.primary,
      color:
        variant === "queen"
          ? theme.palette.text.primary
          : theme.palette.common.white,
    },
    "&:not(.Mui-selected)": {
      color: theme.palette.text.primary,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },
}));
